export default __webpack_public_path__ + "static/media/night.09f61f2d.svg";